import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/components/AuthProvider";
import Home from "@/pages/Home";
import CourseDetail from "@/pages/CourseDetail";
import Lesson from "@/pages/Lesson";
import Live from "@/pages/Live";
import Access from "@/pages/Access";
import Admin from "@/pages/Admin";
import AdminEditor from "@/pages/AdminEditor";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id — process auth FIRST, before any route
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/course/:slug" element={<CourseDetail />} />
      <Route path="/course/:slug/learn/:lessonId" element={<Lesson />} />
      <Route path="/access/:token/learn/:lessonId" element={<Lesson />} />
      <Route path="/live" element={<Live />} />
      <Route path="/access/:token" element={<Access />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/editor/:slug" element={<AdminEditor />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App font-sans text-white">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRouter />
        </BrowserRouter>
      </AuthProvider>
      <WhatsAppButton />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#111111", border: "1px solid #27272A", color: "#fff" } }} />
      <div className="grain-overlay" />
    </div>
  );
}

export default App;
